module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"gunit\">\n    <div id=\"")
    ; __append(escapeFn( containerId ))
    ; __append("\"></div>\n</div>")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-tags/async-gpt-tag.html
// module id = 337
// module chunks = 36